module.exports = __webpack_public_path__ + "img/icon-update.b4ec4466.svg";